import styled from 'styled-components';

import Headline from '../Headline';

export const StyledHeader = styled.header`
  height: var(--header-height);
  padding: 64px var(--side-padding) 32px;

  button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
    padding: 0;
    outline: none;
    cursor: pointer;
  }
`;

export const StyledHeadline = styled(Headline)`
  & > span:first-of-type {
    font-weight: 900;
  }
`;
